export default "__VITE_ASSET__BmZVuksf__"